export const DEFAULT_TINT_PRICE_PER_UNIT = 20;
